import {Box, Button, Grid, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {useRecoilValue} from 'recoil';
import {BEEScorecardService} from '../../../Component/Api/BEEScorecard/BEEScorecard';
import {CoreExportService} from '../../../Component/Api/Export/CoreExportService';
import {IndividualService} from '../../../Component/Api/Individual/IndividualService';
import {CoreStaticDataService} from '../../../Component/Api/StaticData/CoreStaticDataService';
import {DataTable} from '../../../Component/Common/Components/DataTable/DataTable';
import {FilterType, IFilter} from '../../../Component/Common/Components/DataTable/Filters';
import {MDAlert} from '../../../Component/Common/Components/MDAlert';
import {MDBox} from '../../../Component/Common/Components/MDBox';
import {MDProgress} from '../../../Component/Common/Components/MDProgress';
import {MDTypography} from '../../../Component/Common/Components/MDTypography';
import {ColumnSortOption} from '../../../Component/Model/Dto/ColumnSortOption';
import {Export} from '../../../Component/Model/Dto/Export';
import {Individual} from '../../../Component/Model/Dto/Individual';
import {filterColumnValues} from '../../../Component/Model/Dto/ScorecardLicense';
import {ExportKeyValue} from '../../../Component/Model/Dto/Upload';
import {DataImportType, EmployeeTypes, UserActivityActionType} from '../../../Component/Model/Enum/BEE123Enums';
import {EntriesPerPage} from '../../../Component/Model/Table/Table';
import {defaultObject, emptyGuid} from '../../../Helpers/typescriptHelper';
import {BEE123SalariesEditRole, EE123SalariesRole_Edit, UserAdminRole} from '../../../Component/Common/Constants/UserRoles';
import {UserAtom, userRolesState} from '../../../State/user.Atom';
import config from '../../../config';
import {IndividualSalaryModal} from '../../Common/Individual/IndividualSalaryModal';
import {IndividualCentralDataSalaryModal} from '../IndividualModal/IndividualCentralDataSalaryModal';
import {IndividualSalariesTableMapper} from './IndividualSalariesTableMapper';
import {useSignalRConnection} from "../../../Hooks/useSignalRConnection";
import { UserActivityService } from '../../../Component/Api/UserActivity/UserActivityService';
import { CDMSummariesSalariesSection } from '../../../Component/Common/Constants/UserActivityTrackingSections';

export const IndividualSalariesDatatableWithActions = () => {
    const user = useRecoilValue(UserAtom);
    const editRoleAccess = [
        BEE123SalariesEditRole,
        UserAdminRole
    ];
    const eeEditRoleAccess = [
        EE123SalariesRole_Edit,
        UserAdminRole
    ];
    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));
    const isEditableEE = userRoles.some(r => eeEditRoleAccess.includes(r));
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [individualSalariesModal, setIndividualSalariesModal] = useState<boolean>(false);
    const [eeSalaryModal, setEESalaryModal] = useState<boolean>(false);
    const [individualIdSalary, setIndividualIdSalary] = useState<number>(0);
    const [individualleSalariesData, setIndividualSalariesData] = useState<Individual.IndividualSalarySummaryDto[]>([]);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [scorecardId, setScorecardId] = useState<string>('');
    const [scorecardType, setScorecardType] = useState<string>('');

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({defaultValue: 15});
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [filters, setFilters] = useState({});
    const [filterScorecardTypes, setFilterScorecardTypes] = useState<filterColumnValues[]>(defaultObject);
    const [filterScorecardIds, setfilterScorecardIds] = useState<filterColumnValues[]>(defaultObject);
    const [fileExporting, setFileExporting] = useState<boolean>(false);
    const [progress, setProgress] = useState(0);
    const hub = useSignalRConnection("ImportHub");

    const peopleSalariesFilters: Array<IFilter> = [
        {
            label: 'Gender:',
            values: [{ key: 'Male', val: 1 }, { key: 'Female', val: 2 }],
            type: FilterType.multiselect, propname: 'genderIds'
        },
        {
            label: "Scorecard Type:",
            values: filterScorecardTypes,
            type: FilterType.multiselect,
            propname: 'scorecardTypes',
        },
        {
            label: "Scorecard Name:",
            values: filterScorecardIds,
            type: FilterType.multiselect,
            propname: 'scorecardIds',
        },
        {
            label: 'Race:',
            values: [{ key: 'African', val: 1 }, { key: 'Coloured', val: 2 }, { key: 'Indian', val: 3 }, { key: 'White', val: 4 }, { key: 'Non South African', val: 5 }],
            type: FilterType.multiselect, propname: 'raceIds'
        },
        {
            label: 'Occupation Level:',
            values: [{ key: 'Executive Director', val: 1 },
            { key: 'Non Executive Director', val: 2 },
            { key: 'Executive Management', val: 3 },
            { key: 'Other Executive Management', val: 4 },
            { key: 'Senior Management', val: 5 },
            { key: 'Middle Management', val: 6 },
            { key: 'Junior Management', val: 7 },
            { key: 'Semi skilled', val: 8 },
            { key: 'Unskilled', val: 9 },
            { key: 'Unspecified', val: 10 }],
            type: FilterType.multiselect, propname: 'occupationalLevelIds'
        },
        {
            label: 'Employee Type:',
            values: [
                { key: 'Employed By Other', val: 2 },
                { key: 'Employee', val: 1 },
                { key: 'Employee Previously Unemployed', val: 4 },
                { key: 'Unemployed', val: 3 }],
            type: FilterType.multiselect, propname: 'employeeTypeIds'
        },
        {
            label: 'Disabled:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: FilterType.multiselect, propname: 'disabledValues'

        },
        {
            label: 'Province:',
            values: [
                { key: 'Unspecified', val: 0 },
                { key: 'National (NAT)', val: 1 },
                { key: 'Eastern Cape (EC)', val: 2 },
                { key: 'Free State (FS)', val: 3 },
                { key: 'Gauteng (GP)', val: 4 },
                { key: 'KwaZulu-Natal (KZN)', val: 5 },
                { key: 'Limpopo (LP)', val: 6 },
                { key: 'Mpumalanga (MP)', val: 7 },
                { key: 'North West (NW)', val: 8 },
                { key: 'Northern Cape (NC)', val: 9 },
                { key: 'Western Cape (WC)', val: 10 },
            ],
            type: FilterType.multiselect, propname: 'provinceIds'
        },
        {
            label: 'Y.E.S. Employee:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: FilterType.multiselect, propname: 'isYesEmployeeValues'
        },
        {
            label: 'Y.E.S. Absorbed:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: FilterType.multiselect, propname: 'isYesAbsorbedValues'
        },
        {
            label: 'Start Period:',
            values: [],
            type: FilterType.dateRange, propname: 'startDateRange'
        },
        {
            label: 'Termination Period:',
            values: [],
            type: FilterType.dateRange, propname: 'endDateRange'
        }
    ];

    const individualSalariesSearchRequest: Individual.IndividualSalarySearchRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        registrationId: emptyGuid,
        scorecardIds: [],
        genderIds: [],
        raceIds: [],
        employeeTypeIds: [],
        disabledValues: [],
        occupationalLevelIds: [],
        provinceIds: [],
        isYesEmployeeValues: [],
        isYesAbsorbedValues: [],
        scorecardTypes: [],
        hireDateStart: undefined,
        hireDateEnd: undefined,
        terminationDateStart: undefined,
        terminationDateEnd: undefined,
        columnSortOptions: columnSortOptions,
        employeeTypeIdsToIncludeForEE: [EmployeeTypes.Employee, EmployeeTypes.Employee_Previously_Unemployed]
    };

    const GetScorecardTypes = async () => {
        try {
            const scorecardType = await CoreStaticDataService.getAllScorecardTypes();
            setFilterScorecardTypes(
                scorecardType.data.map((data) => {
                    return { key: data.name, val: data.id };
                })
            );
        } catch (error) {
            console.log(error);
        }
    };

    const GetScorecardNameByReg = async () => {
        try {
            const scorecardNameByReg = await BEEScorecardService.getAllScorecards();
            const beeScorecards = scorecardNameByReg.data.beeScorecards;
            const eeScorecards = scorecardNameByReg.data.eeScorecards;
            const allScorecards = beeScorecards.concat(eeScorecards);
            setfilterScorecardIds(
                allScorecards.map((data) => {
                    return { key: data.scorecardName, val: data.scorecardId };
                })
            );
        } catch (error) {
            console.log(error)
        }
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    const filtersChanged = (filterProps: any) => {
        let startDateFrom = filterProps['startDateRange']?.start;
        let startDateTo = filterProps['startDateRange']?.end;
        let endDateFrom = filterProps['endDateRange']?.start;
        let endDateTo = filterProps['endDateRange']?.end;
        setFilters({ ...filterProps, startDateFrom, startDateTo, endDateFrom, endDateTo });
    }

    const onEditPeopleSalariesRow = (id: number, scorecardId: string, scorecardType: string) => {
        setScorecardId(scorecardId);
        setIndividualIdSalary(id);
        setIndividualSalariesModal(true);
        if (scorecardType === "Employment Equity") {
            setEESalaryModal(true);
            setIndividualSalariesModal(false)
        }
        else {
            setIndividualSalariesModal(true);
            setEESalaryModal(false);
        }
        setScorecardType(scorecardType);
    }

    const closeModal = () => {
        fetchData();
        setIndividualSalariesModal(false);
        setEESalaryModal(false);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let request = { ...individualSalariesSearchRequest, ...filters };
            let resp = await IndividualService.IndividualSalarySearch(request);
            if (resp.data) {
                setIndividualSalariesData(resp.data.results);
                setFilteredItemsCount(resp.data.filteredItemsCount);
                setTotalItemsCount(resp.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error);
            setFilteredItemsCount(0);
            setTotalItemsCount(0);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        GetScorecardTypes();
        GetScorecardNameByReg();
        UserActivityService.createActivityLog({
            section: CDMSummariesSalariesSection,
            actionType: UserActivityActionType.View,
            actionDescription: "View salaries",
            requestUrl: window.location.href
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue, columnSortOptions, filters]);

    useEffect(() => {
        if (config.enable_CDMExportFunctionality === 'false') return;

        (async () => {
            try {
                if (!hub.isConnected) {
                    await hub.start();
                }

                hub.on(`exportProgress-${user.username}-${DataImportType[DataImportType.Salary]}`, (data: any) => {
                    setFileExporting(true);
                })
                hub.on(`exportProgressUpdate-${user.username}-${DataImportType[DataImportType.Salary]}`, (data: any) => {
                    setProgress(data.progress);
                    setFileExporting(true);
                })
                hub.on(`exportProgressFailed-${user.username}-${DataImportType[DataImportType.Salary]}`, (data: any) => {
                    setFileExporting(false);
                    toast.error("Export could not be completed");
                })
                hub.on(`exportProgressCompleted-${user.username}-${DataImportType[DataImportType.Salary]}`, (data: any) => {
                    setFileExporting(false);
                    setProgress(0);
                    window.open(data.ExportUrl, "_blank");
                })
            } catch (error) {
                console.error("SignalR connection failed:", error);
            }
        })();
    }, []);

    const coreFileExport = async () => {
        let params: ExportKeyValue[] = [];

        let filterRequest = { ...individualSalariesSearchRequest, ...filters };
        for (const [name, value] of Object.entries(filterRequest)) {
            if (!(name === "hireDateStart" || name === "hireDateEnd" || name === "terminationDateStart" || name === "terminationDateEnd")) {
                const tempExportKeyValue = { key: name, value: value?.toString() };
                params.push(tempExportKeyValue);
            }
        }

        const filteredParameter = params.filter(item => item.key !== "registrationId");

        const request: Export.DynamicFileExportDto = {
            importType: DataImportType.Salary,
            parameters: filteredParameter,
        };
        setFileExporting(true);
        try {
            await CoreExportService.FileExportFunction(request);
        } catch (error) {
            console.log(error);
            toast.error("Export could not be completed");
        } finally {
            params = [];
        }
    }

    const individualSalariesTableData = IndividualSalariesTableMapper(individualleSalariesData, onEditPeopleSalariesRow, isEditable, isEditableEE);

    return (
        <>
            <DataTable
                key={totalItemsCount}
                table={individualSalariesTableData}
                filters={peopleSalariesFilters}
                canSearch
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                isLoading={isLoading}
                filtersChanged={filtersChanged}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
            >
            </DataTable>

            {individualSalariesModal && <IndividualCentralDataSalaryModal showIndividualSalariesModal={individualSalariesModal} closeIndividualSalariesModal={closeModal} scorecardId={scorecardId} id={individualIdSalary} scorecardType={scorecardType} />}
            {eeSalaryModal && <IndividualSalaryModal showIndividualModal={eeSalaryModal} closeIndividualModal={closeModal} scorecardId={scorecardId} id={individualIdSalary} section={CDMSummariesSalariesSection} />}

            <Grid container >
                <Grid item xs={12} lg={12}>
                    <MDBox mt={4}>
                        {config.enable_CDMExportFunctionality === 'true' &&
                            <MDAlert color='light'>
                                {fileExporting ?
                                    <Grid container justifyContent="center" alignItems="center" direction="column">
                                        <Typography variant="h6" mb={1}>Exporting file...</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <Box sx={{ width: '100%', mr: 1 }}>
                                                <MDProgress variant="determinate" value={progress} style={{ width: '100%' }} />
                                            </Box>
                                            <Box sx={{ minWidth: 35 }}>
                                                <Typography variant="body2" color="text.secondary">{`${Math.round(progress)}%`}</Typography>
                                            </Box>
                                        </Box>
                                    </Grid> :
                                    <MDTypography component='span' variant='body' fontSize='0.93rem' fontWeight='regular'>
                                        {filteredItemsCount > 0 ?
                                            <p style={{ marginBottom: "0.2rem" }}> Click<Button variant="text" onClick={() => { coreFileExport() }} size="small" style={{ fontSize: "inherit", padding: "0.25rem", paddingBottom: "0.4rem", minWidth: "0", textTransform: "none" }}>here</Button>
                                                to Export data to a file</p> :
                                            <p></p>
                                        }
                                    </MDTypography>
                                }
                            </MDAlert>
                        }
                    </MDBox>
                </Grid>
            </Grid>
        </>
    );
}
